import React, { memo, useState } from 'react'
import { Link } from '@reach/router'
import { AppBar, Hidden, IconButton, Slide } from '@material-ui/core'
import { Menu } from '@styled-icons/boxicons-regular/Menu'
import { ReactComponent as LogoHorizontal } from '../../assets/svgs/logo-horizontal.svg'
import Navbar from '../Navbar'
import Topbar from '../Topbar'
import Sidebar from '../Sidebar'
import * as Styled from './styled'

const Header = ({ appBarPosition }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Slide appear={false} direction='down' in={true}>
        <Styled.AppBar position={appBarPosition}>
          <Topbar />
          <Styled.Toolbar>
            <Hidden lgUp>
              <IconButton
                edge='start'
                color='inherit'
                aria-label='menu'
                onClick={() => setOpen(true)}
              >
                <Menu style={{ height: '27px', width: '27px' }} />
              </IconButton>
            </Hidden>

            <Link to='/'>
              <Styled.Logo>
                <LogoHorizontal alt='W.Dental' />
              </Styled.Logo>
            </Link>

            <Navbar />
          </Styled.Toolbar>
        </Styled.AppBar>
      </Slide>
      <Sidebar open={open} onClose={() => setOpen(false)} />
    </>
  )
}

Header.defaultProps = {
  appBarPosition: undefined
}

export default memo(Header)
